var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { formatNumber } from './formatNumber';
import { parseNumber } from './internal/parseNumber';
import { NON_BREAKING_SPACE } from './internal/unicode';
export var formatCurrency = function (amount, opts) {
    var locale = opts.locale;
    var _a = __assign({}, opts), _b = _a.prefix, prefix = _b === void 0 ? "kr".concat(NON_BREAKING_SPACE) : _b, _c = _a.postfix, postfix = _c === void 0 ? ',–' : _c;
    var parsed = parseNumber(amount, locale);
    // A ',-' postfix is not allowed for amounts with øre, see:
    // http://www.sprakradet.no/svardatabase/sporsmal-og-svar/kronebelop-rekkjefolgje-komma-og-strek/
    if (typeof parsed === 'number' && parsed % 1 !== 0) {
        var decimalPostfix = ![',–', ',-'].includes(postfix) ? postfix : '';
        return "".concat(prefix).concat(formatNumber(amount, {
            decimals: 2,
            locale: locale,
        })).concat(decimalPostfix);
    }
    return "".concat(prefix).concat(formatNumber(amount, { locale: locale })).concat(postfix);
};
